import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const MentalNoiseAndAnxietySection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel sectionId="mental-noise-and-anxiety" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>
      Mental noise and anxiety reinforce one another. When the mind continuously predicts negative
      outcomes, you begin responding as though those outcomes were already confirmed.
    </GuideLead>
    <GuideSectionLabel>The cycle</GuideSectionLabel>
    <GuideCardGrid columns={2}>
      <GuideCard
        iconKey="thinking"
        title="1. The mind imagines a threat"
        description="Mental noise generates a worst-case scenario."
      />
      <GuideCard
        iconKey="stress"
        title="2. Behavior follows the prediction"
        description="Reactive signals appear: rechecking messages, rehearsing worst cases, delaying decisions."
      />
      <GuideCard
        iconKey="energy"
        title="3. Reactions reinforce belief"
        description="The reactive behavior is taken as evidence that something really is wrong."
      />
      <GuideCard
        iconKey="awareness"
        title="4. The mind searches for more evidence"
        description="The cycle deepens as the brain looks for proof."
      />
    </GuideCardGrid>
    <GuideCallout variant="amber">
      Over time, this cycle makes it difficult to distinguish between real danger and imagined risk.
    </GuideCallout>
    <GuideCallout>Reducing mental noise helps interrupt this loop.</GuideCallout>
  </GuidePanel>
);

export default MentalNoiseAndAnxietySection;
